module.exports = __webpack_public_path__ + "static/img/Foresite-Default.3c97e92.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Foresite-Default.png
// module id = 1587
// module chunks = 0